export enum SubscriptionStatusEnum {
  ON_TRIAL = "on_trial",
  ACTIVE = "active",
  PAUSED = "paused",
  PAST_DUE = "past_due",
  UNPAID = "unpaid",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
}
